$(function () {
	const $carousel = $('.owl-carousel');
	const observer = new IntersectionObserver(function (entries, observer) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				$(entry.target).owlCarousel({
					loop:            true,
					margin:          10,
					items:           1,
					responsiveClass: true,
					navText:         ['<span class="icon-navigation-icon-left text-2xl"></span>', '<span class="icon-navigation-icon-right text-2xl"></span>'],
					responsive:      {
						0:   {
							items: 1,
							nav:   false
						},
						640: {
							items: 1,
							nav:   true
						},
					},
					onInitialized:   function () {
						$('.owl-prev').attr('aria-label', 'Previous slide');
						$('.owl-next').attr('aria-label', 'Next slide');

						$('.owl-dot').each(function (index) {
							$(this).attr('aria-label', 'Slide ' + (index + 1));
						});
					}
				});

				observer.unobserve(entry.target);
			}
		});
	}, {rootMargin: '100px', threshold: 0});

	if ($carousel.length) {
		$carousel.each(function () {
			observer.observe(this);
		});
	}
});

$(document).ready(function() {
	$("#owl-our-team").owlCarousel({
		items: 3,
		nav: true,
		navText: [
			'<span class="icon-navigation-icon-left text-2xl"></span>',
			'<span class="icon-navigation-icon-right text-2xl"></span>'
		],
		loop: true,
		margin: 22,
		autoplay: true,
		autoplayHoverPause: true,
		autoplayTimeout: 2000,
		smartSpeed: 500,
		slideBy: 1,
		dotsEach: true,
		responsive: {
			0: {
				items: 1,
				margin: 12
			},
			450: {
				items: 2,
				margin: 18
			},
			768: {
				items: 3,
				margin: 22
			}
		}
	});

	$('.owl-prev').attr('aria-label', 'Previous slide');
	$('.owl-next').attr('aria-label', 'Next slide');
	$('.owl-dot').each(function (index) {
		$(this).attr('aria-label', 'Slide ' + (index + 1));
	});
});